import { render, staticRenderFns } from "./OrganizationRemoveUserModel.vue?vue&type=template&id=be4f417c&scoped=true&"
import script from "./OrganizationRemoveUserModel.vue?vue&type=script&lang=js&"
export * from "./OrganizationRemoveUserModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4f417c",
  null
  
)

export default component.exports